function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImg6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "215.13 257.13 154.13 212.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Hand--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M368.78,463.66l-.09,0c-1.05.26-2.11.51-3.17.75l-.09,0c-1,.24-2,.47-3.07.69l-.65.13-3.08.62c-1.15.22-2.3.43-3.46.63-1.31.23-2.64.45-4,.66-1,.16-2,.3-3,.45h-.08c-2.25.32-4.5.61-6.78.86l-.68.08-3,.31-.42,0-3.42.3h0l-3.61.28h-.11c-1.12.08-2.24.14-3.37.2-2.66.15-5.33.25-8,.32-1.11,0-2.23.05-3.36.06s-2.49,0-3.74,0h0c-1.25,0-2.49,0-3.73,0l-1.32,0H306l-3-.07c-1.06,0-2.11-.06-3.17-.11-1.73-.06-3.48-.15-5.23-.25l-1.53-.09c-.76,0-1.51-.08-2.27-.13-.56,0-1.11-.09-1.67-.12l-.25,0c-1.35-3.3-2.61-6.17-3.67-8.2-2.64-5.05-12.91-18.77-12.91-18.77s-10.55.12-24.28-12.73-29.79-30.14-29.55-43.51c.18-9.58-1.59-15.64-2.43-21.15a29.75,29.75,0,0,1-.39-6.45c.19-2.87.93-6,.9-9.34,0-5.67-.67-11.61,1.86-14.61,4-4.78,15.93-.48,18.32,9.25s3.53,30.16,7.53,30,4.17-15.16,9.51-30.82l2.54-17,1-32.79.07-6.54s-2.9-16.47,1.8-24.95c0,0,4.75-8.13,10.29-1.2,5,6.27,4.86,8.33,8.49,31s.35,36.22,4.15,36.6,4.85-2.85,4.83-8.48.14-16.26,8.64-16.16,13.91,3.34,13.5,11.26-.44,14.26.89,14.73c0,0-1.51-8.76.36-13.92.82-2.26,2.34-4.95,9.4-2.2s7.77,7.48,8.54,12.63,1.82,9.46,1.82,9.46,8.59-.46,11.73,5.36,6.25,22.41,7.35,28.31c2.9,15.45-1.18,32.41-3.54,40.32a13.31,13.31,0,0,0,.55,9.24C349.42,425.87,360.13,445.5,368.78,463.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.88,429.5c-.52-5.57-10,2.82-32.29-16.72-24.74-21.68-18.4-58.84-22.77-57s-4.76,9.12-4.76,9.12c.84,5.51,2.61,11.57,2.43,21.15-.24,13.37,15.82,30.67,29.55,43.51s24.28,12.73,24.28,12.73,10.27,13.72,12.91,18.77c1.06,2,2.32,4.9,3.67,8.2l.25,0c.56,0,1.11.08,1.67.12.76,0,1.51.1,2.27.13l1.53.09c1.75.1,3.5.19,5.23.25-2.35-5.62-4.32-10.12-5.39-12.11C290.2,449.82,276.53,436.44,275.88,429.5Z",
    style: {
      fill: "#10A7D0",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.91,338.26a6.11,6.11,0,0,0-.23,2.52,33.55,33.55,0,0,0,2.73,10.76.66.66,0,0,0,1.26-.35,108.73,108.73,0,0,1-1.46-15.31C298.21,335,296.21,337.47,295.91,338.26Z",
    style: {
      fill: "#10A7D0",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.77,348.35a94.21,94.21,0,0,1-1.41-10.12c0-.16-.08-.2-.2-.15a7.21,7.21,0,0,0-2,2.67,6,6,0,0,0-.06,2.53,28,28,0,0,0,1.34,5.66,1.13,1.13,0,0,0,1.43.75A1.1,1.1,0,0,0,320.77,348.35Z",
    style: {
      fill: "#10A7D0",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.42,286.59l-.07,6.53-1,32.78-2.54,17c-4.29,12.58-5.24,24.71-7.52,29.09l-.05.5c-.1,1,0,2.41.94,2.58.7.13,1.33-.59,1.79-1.24,8.51-12.15,15.05-33.18,11.24-59.22-.8-5.51,0-17.76,3.81-21.72-1.6-12.12-3.77-18.44-5.44-29.88C254.82,271.78,257.42,286.59,257.42,286.59Z",
    style: {
      fill: "#10A7D0",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.62,340.07a9.53,9.53,0,0,0,0,4,49.64,49.64,0,0,0,4.53,14.26,1.32,1.32,0,0,0,2.47-.87,161.54,161.54,0,0,1-3.65-21.4C270.82,334.71,268,338.79,267.62,340.07Z",
    style: {
      fill: "#10A7D0",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.39,297.44a4.28,4.28,0,0,0-2.93-3.93c-2-.75-5.22-.83-4.84.81a12.24,12.24,0,0,1,3.37,1.14c3.27,2.4,1.27,4.6,1.27,4.6C275.81,300.87,277.3,299.18,277.39,297.44Z",
    style: {
      fill: "#10A7D0",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.86,342.41c-.05-.66-1.47,1.33-1.66,2a4.62,4.62,0,0,0,0,2,21.7,21.7,0,0,0,1,4.36.91.91,0,0,0,1.75-.46A72.83,72.83,0,0,1,334.86,342.41Z",
    style: {
      fill: "#10A7D0",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.9,469.27c-1.42-3.5-2.56-6.07-3.67-8.2-2.64-5.05-12.91-18.78-12.91-18.78s-10.54.13-24.28-12.72-29.79-30.14-29.55-43.51-3.3-19.9-2.82-27.6c.18-2.87.93-6,.89-9.34,0-5.68-.66-11.61,1.86-14.61,4-4.78,15.93-.48,18.32,9.25s3.54,30.16,7.54,30,4.17-15.16,9.51-30.82l2.54-17,1-32.78.07-6.53s-2.9-16.48,1.8-25c0,0,4.75-8.13,10.29-1.2,5,6.27,4.86,8.33,8.49,31s.35,36.23,4.15,36.62,4.85-2.86,4.82-8.49.15-16.26,8.66-16.15,13.89,3.34,13.5,11.25-.45,14.26.88,14.74c0,0-1.51-8.77.35-13.93.82-2.26,2.35-4.95,9.41-2.21s7.77,7.49,8.53,12.64,1.83,9.46,1.83,9.46,8.59-.46,11.73,5.36,6.25,22.42,7.36,28.32c2.88,15.44-1.19,32.4-3.56,40.31a13.37,13.37,0,0,0,.56,9.24c3.2,7.31,13.92,26.94,22.56,45.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.57,345.88a9.89,9.89,0,0,1,3.68-2.54c4.73-2.13,6.36-2.47,5.76-7.57",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.56,351.32c.68-.32,1.39-.62,2.15-.89",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.8,357.25a22.22,22.22,0,0,1,6.2-5.12",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.19,264a2.35,2.35,0,0,0,2.43,2.36c2.44.06,8.85,1.4,8.09-1.5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.61,291.7a18.13,18.13,0,0,1,7.08.18",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264,292.9s.69-.28,1.82-.6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.89,329.39c.34,2.67,2.18,9.05,2.18,9.05",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.92,373.78c5.06,12.77,9,25,15.06,38.26",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.79,361.68c1,2.21,2,4.4,2.87,6.56",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 336.4,
    y1: 366.49,
    x2: 336.64,
    y2: 378.95,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 336.29,
    y1: 360.57,
    x2: 336.35,
    y2: 363.88,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.51,332.22c-.11,3.11-.19,5.53-.27,8.07-.1,3,2,7,3.15,9.84,2,5,2.95,11.14,4.3,16.36",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.51,371.36l2.82,11.85",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.94,337.55l-.6,5.5a12.09,12.09,0,0,0,1.25,6.67l.84,12.22",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.29,391.92a47.56,47.56,0,0,0,19.26,22.28",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.94,427.89l7.46,3.27c1.09,4.12-1.19,6.58,10.26,19.87",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg6);
export default __webpack_public_path__ + "static/media/img6.36d25e2c3c75345198f734d06552841f.svg";
export { ForwardRef as ReactComponent };